import { useHistory, useLocation } from 'react-router-dom';
import { urlSearchFactory } from '../helpers/urlSearch';

export default () => {
  const history = useHistory();
  const { search } = useLocation();
  return urlSearchFactory({ history, search });
};
